import styled from "styled-components";
import { BaseButton } from "./DefaultButton";
import { colors } from "common/const/colors";
import { CloseIcon, IconWrapper } from "common/components/icon";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { TextBadge } from "common/components";

const TagButtonWrapper = styled(BaseButton)`
  width: auto;
  height: 2.25rem;
  flex-shrink: 0;
  white-space: nowrap;
  padding: 0.5rem 0.75rem;

  border-radius: 5px;
  background-color: ${({ $blank, $selected }) => {
    if ($blank) return "transparent";
    if ($selected) return colors.MainBlue;
    return colors.Gray;
  }};
  border: ${({ $blank }) => ($blank ? `1px dashed ${colors.Gray}` : "none")};
  color: ${({ $blank, $selected }) => {
    if ($blank) return colors.LightNavy;
    if ($selected) return colors.White;
    return colors.DarkNavy;
  }};
`;

export const TagButton = ({
  text,
  value,
  blank = false,
  selected,
  onSelect,
}) => {
  const isControlled =
    typeof selected === "boolean" && typeof onSelect === "function";
  const [internalSelected, setInternalSelected] = useState(false);
  const isSelected = isControlled ? selected : internalSelected;

  const handleClick = () => {
    const next = !isSelected;
    if (isControlled) onSelect(value);
    else setInternalSelected(next);
  };

  return (
    <TagButtonWrapper
      $blank={blank}
      $selected={isSelected}
      aria-pressed={isSelected}
      onClick={handleClick}>
      <TextBadge>{text}</TextBadge>
      {isSelected && (
        <IconWrapper size="1.25rem">
          <CloseIcon />
        </IconWrapper>
      )}
    </TagButtonWrapper>
  );
};
